import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentBankAccount } from '../../../../../models/entities/payment-bank-account';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';

export interface RemoveDepositAccountDialogInput
{
    account: PaymentBankAccount | UnifiedBankAccount;
    replacementCandidates?: UnifiedBankAccount[];
}

export interface RemoveDepositAccountDialogResult
{
    success: boolean;
}

@Component({
    selector: 'app-remove-deposit-account-dialog',
    templateUrl: './remove-deposit-account-dialog.component.html',
    styleUrls: ['./remove-deposit-account-dialog.component.scss'],
})
export class RemoveDepositAccountDialogComponent implements OnInit
{

    replacementDepositAccount: UnifiedBankAccount = null;
    isReplacementRequestInFlight = false;

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _growlerService: GrowlerService,
            private _dialogRef: MatDialogRef<RemoveDepositAccountDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: RemoveDepositAccountDialogInput,
    ) {
    }

    ngOnInit() {
    }

    closeDialog() {
        this._dialogRef.close({success: false});
    }

    replaceDepositAccount() {
        this.isReplacementRequestInFlight = true;
        this._bankAccountsService.removeDepositAccount(null, this.data.account.id, this.replacementDepositAccount.id)
                .subscribe({
                    next: () => {
                        this._dialogRef.close({success: true});
                        this.isReplacementRequestInFlight = false;
                    },
                    error: (err) => {
                        this._growlerService.error('Error Replacing Deposit Account', 'The server encountered an unexpected error while replacing this deposit account. Please try again.');
                        this.isReplacementRequestInFlight = false;
                    },
                });
    }

}
